/**
 * Fiche machine en page pleine — compatibilité des liens existants
 * (`/machines/:id`, étiquettes déjà imprimées, favoris).
 *
 * Ce n'est plus la destination normale : depuis Le Parc, la même fiche
 * s'affiche directement dans la colonne de droite, sans quitter `/parc`
 * (voir `FicheMachine.tsx`, dont cette page n'est qu'un habillage).
 */
import { Link, useNavigate, useParams } from 'react-router-dom';

import { FicheMachine } from '../composants/FicheMachine';

export function AssetDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return <div className="vide">Machine introuvable.</div>;
  }

  return (
    <FicheMachine
      assetId={id}
      breadcrumb={<Link to="/parc">← Parc</Link>}
      onArchived={() => navigate('/parc')}
    />
  );
}
